var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.classList,
      style: _vm.fixedBackground ? _vm.fixedStyles : null
    },
    [
      typeof _vm.aspectRatio !== "boolean"
        ? [
            _c(
              "div",
              { staticClass: "image__ratio", style: _vm.aspectRatioStyles },
              [
                !_vm.fixedBackground
                  ? _c("img", {
                      attrs: { alt: _vm.alt, src: _vm.source },
                      on: { error: _vm._onError, load: _vm._onLoad }
                    })
                  : _vm._e()
              ]
            )
          ]
        : [
            !_vm.fixedBackground
              ? _c("img", {
                  attrs: { alt: _vm.alt, src: _vm.source },
                  on: { error: _vm._onError, load: _vm._onLoad }
                })
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }